const moduleActiveTabCreateAdmission = {
    namespaced: true,
    state: {
        activeTabNumber: 0,
    },
    getters: {
        getActiveTabNumber(state) {
            return state.activeTabNumber;
        },
    },
    mutations: {
        setActiveTabNumber(state, payLoad) {
            state.activeTabNumber = payLoad;
        },
    },
};
export default moduleActiveTabCreateAdmission;
